import LeafletMapController from "./Controller/LeafletMapController";
import AddressListController from "./Controller/AddressListController";
class MapCreator {
    valuesInArray(arrayA, arrayB) {
        return arrayA.every(value => arrayB.includes(value));
    }
    constructor() {
        const elements = document.querySelectorAll('.frame-type-tilemaps_map');
        for (let i = 0; i < elements.length; i++) {
            const container = elements[i];
            const mapElement = container.querySelector('.map');
            const addressList = new AddressListController(container);
            const maps = new LeafletMapController(mapElement);
            maps.addMarkers(addressList.items);
        }
    }
}
export default new MapCreator();
